export default __webpack_public_path__ + "media/images/dashboard_icons/simple-rsvps-e5a9c48065bffc7f9b2b6d4d070e75ec.svg";